/**
 * releaseNotes — the single source of truth for the v2 "What's New" overlay.
 *
 * Bump RELEASE_NOTES_VERSION to re-announce the note on the next release: the
 * dismissal flag is keyed by version (see useReleaseNotes), so a new version
 * string makes the modal auto-open once more for everyone.
 *
 * Each highlight: { icon, title, body, tryIt?, badge? }. `tryIt` is the
 * product-led "try this" nudge; `badge` is an optional status pill (e.g. "Beta").
 */

export const RELEASE_NOTES_VERSION = "10.0";

export const RELEASE_NOTES = {
  version: RELEASE_NOTES_VERSION,
  title: "Welcome to the updated Plex",
  subtitle: "A faster, calmer way to run your research — here's what's new.",
  highlights: [
    {
      icon: "💬",
      title: "Chat that doesn't lose your place",
      body: "Start a question and browse away — your answer keeps streaming and your history stays put.",
      tryIt: "Ask something, click another chat, then come back.",
    },
    {
      icon: "🧠",
      title: "A coach that remembers",
      body: "Your preferences and context carry across chats, so you don't repeat yourself.",
      tryIt: "Tell it how you like answers formatted.",
    },
    {
      icon: "📑",
      title: "Sources & evidence on every claim",
      body: "Answers come with citations and evidence chains you can open and verify.",
      tryIt: "Open the Sources panel on any answer.",
    },
    {
      icon: "📁",
      title: "Files",
      badge: "Stable",
      body: "Upload your own data and bring it straight into the conversation.",
      tryIt: "Drag a CSV into the composer.",
    },
    {
      icon: "🧮",
      title: "Data analysis with code",
      badge: "Beta",
      body: "The coach can run code on your data to compute, chart, and analyze on the fly.",
      tryIt: "Ask it to chart a column from your file.",
    },
    {
      icon: "🗂️",
      title: "Workspace → Programs → Projects",
      body: "Organize research by area; each project is a folder of related chats.",
    },
    {
      icon: "⌨️",
      title: "Command palette",
      body: "Press ⌘K from anywhere to jump to a program, project, or chat.",
    },
  ],
};

export default RELEASE_NOTES;
